import html from '../accessDenied.html.template';
import { default as BaseModal } from '../../base.Modal.js';

import string_it from '../localization/it.js';
import string_en from '../localization/en.js';
import commons_it from '../../../localization/commons_it.js';
import commons_en from '../../../localization/commons_en.js';
import Utils from '../../../js/utils/base.Utils';

export default class AccessDeniedModal extends BaseModal {

  constructor(params){
    super({
      html: html
    }, params)
    this.localStrings = {
      en: {...commons_en[0], ...string_en[0]},
      it: {...commons_it[0], ...string_it[0]}
    }
    this.goToView('#accessDeniedHeaderTemplate', '#accessDeniedTemplate');
  }

  goToView(action, body){
    
    const kendoData = {}
    $(this.wrapper).find('.actions').html(kendo.template($(action).html())({}));
    $(this.wrapper).find('.body').html(kendo.template($(body).html())(kendoData));
    kendo.bind($(this.wrapper), this.localStrings);
  }
}
